export const getLoginUrl = (location) => {
    const cvmRedirect = location.pathname === "/tournaments";
    const queryParams = new URLSearchParams(location.search);
    const paramValue = queryParams.get('ref');

    // Determine the redirect URL based on conditions
    return cvmRedirect && paramValue === "cvm"
        ? process.env.REACT_APP_CVM_LOGIN_URL // CVM login URL
        : process.env.REACT_APP_LOGIN_URL;    // Default login URL
};